import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, Package, Search, MessageSquareOff, Banknote, MailX, Cpu, RotateCcw, Dices, XCircle, Lock, ShoppingCart, TrendingDown, ArrowRight } from 'lucide-react';
const pains = [{
  sku: 'ERR-001',
  icon: Package,
  text: 'No sabés qué servicio freelance podés ofrecer hoy'
}, {
  sku: 'ERR-002',
  icon: Search,
  text: 'Pasás horas buscando clientes sin resultados'
}, {
  sku: 'ERR-003',
  icon: MessageSquareOff,
  text: 'Los prospectos preguntan el precio y desaparecen'
}, {
  sku: 'ERR-004',
  icon: Banknote,
  text: 'No sabés cómo cobrar en dólares desde Argentina'
}, {
  sku: 'ERR-005',
  icon: MailX,
  text: 'Tus propuestas no generan respuestas'
}, {
  sku: 'ERR-006',
  icon: Cpu,
  text: 'No sabés qué pedirle a la IA para ahorrar tiempo'
}, {
  sku: 'ERR-007',
  icon: RotateCcw,
  text: 'Cada mes empezás desde cero sin clientes recurrentes'
}, {
  sku: 'ERR-008',
  icon: Dices,
  text: 'El ingreso extra depende de la suerte y no de un sistema que funcione'
}];
export function PainSection() {
  return <section className="pt-14 pb-12 relative overflow-hidden" data-id="element-507">
      <div className="container mx-auto px-4 relative z-10" data-id="element-508">
        {/* Browser-style window frame wrapping the entire section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative max-w-5xl mx-auto" data-id="element-509">
          {/* Outer subtle red glow */}
          <div className="absolute -inset-1 bg-gradient-to-r from-danger/30 via-danger/20 to-danger/30 rounded-3xl blur-xl opacity-50" data-id="element-510"></div>

          <div className="relative bg-gradient-to-br from-graphite via-petroleum to-graphite border border-danger/30 rounded-2xl overflow-hidden shadow-2xl shadow-danger/10" data-id="element-511">
            {/* Browser chrome top bar */}
            <div className="bg-graphite/80 px-4 py-2.5 border-b border-white/10 flex items-center gap-3" data-id="element-512">
              <div className="flex gap-1.5" data-id="element-513">
                <span className="w-2.5 h-2.5 rounded-full bg-danger" data-id="element-514"></span>
                <span className="w-2.5 h-2.5 rounded-full bg-electric" data-id="element-515"></span>
                <span className="w-2.5 h-2.5 rounded-full bg-energy" data-id="element-516"></span>
              </div>
              <div className="flex-1 flex items-center justify-center" data-id="element-517">
                <div className="bg-petroleum/80 border border-white/10 rounded-md px-3 py-1 flex items-center gap-2 text-[10px] md:text-xs text-textsecondary font-mono max-w-xs w-full" data-id="element-518">
                  <Lock className="w-3 h-3 text-energy/60" data-id="element-519" />
                  <span className="truncate" data-id="element-520">
                    tu-cuenta-actual.freelancer.io/dashboard
                  </span>
                </div>
              </div>
              <span className="text-textsecondary text-[10px] hidden md:block font-mono" data-id="element-521">
                v1.0
              </span>
            </div>

            {/* Tab bar */}
            <div className="flex items-center gap-1 px-4 pt-3 bg-petroleum/40 border-b border-white/5" data-id="element-522">
              <button className="px-3 py-2 text-xs text-textsecondary/60 border-b-2 border-transparent" data-id="element-523">
                <ShoppingCart className="w-3.5 h-3.5 inline mr-1.5" data-id="element-524" />
                Pedidos <span className="text-textsecondary/40" data-id="element-525">(0)</span>
              </button>
              <button className="px-3 py-2 text-xs text-textsecondary/60 border-b-2 border-transparent" data-id="element-526">
                <Banknote className="w-3.5 h-3.5 inline mr-1.5" data-id="element-527" />
                Ingresos <span className="text-textsecondary/40" data-id="element-528">(USD 0)</span>
              </button>
              <button className="px-3 py-2 text-xs text-danger font-bold border-b-2 border-danger flex items-center gap-1.5 ml-1 bg-danger/5 rounded-t" data-id="element-529">
                <AlertTriangle className="w-3.5 h-3.5" data-id="element-530" />
                Errores{' '}
                <span className="bg-danger text-white text-[9px] font-extrabold rounded-full px-1.5 py-0.5 ml-1" data-id="element-531">
                  8
                </span>
              </button>
            </div>

            {/* System alert banner */}
            <div className="bg-danger/10 border-b border-danger/20 px-4 md:px-6 py-3 flex items-start gap-3" data-id="element-532">
              <AlertTriangle className="w-4 h-4 text-danger shrink-0 mt-0.5 animate-pulse" data-id="element-533" />
              <div className="flex-1 min-w-0" data-id="element-534">
                <p className="text-xs md:text-sm text-danger font-bold uppercase tracking-wider" data-id="element-535">
                  ⚠ 8 errores detectados · Cuenta sin facturación
                </p>
                <p className="text-[11px] md:text-xs text-textsecondary mt-0.5 font-mono" data-id="element-536">
                  Última actividad facturable:{' '}
                  <span className="text-danger" data-id="element-537">nunca</span> · Reintentos
                  automáticos agotados.
                </p>
              </div>
              <span className="text-[10px] text-textsecondary/60 font-mono whitespace-nowrap hidden md:block" data-id="element-538">
                hace 0d 0h 0m
              </span>
            </div>

            {/* Header content area */}
            <div className="p-6 md:p-10" data-id="element-539">
              {/* Badge */}
              <div className="flex justify-center mb-5" data-id="element-540">
                <div className="inline-flex items-center gap-2 bg-danger text-white px-4 py-1.5 rounded-full text-[10px] md:text-xs font-extrabold uppercase tracking-wider shadow-lg shadow-danger/40" data-id="element-541">
                  <XCircle className="w-3.5 h-3.5" data-id="element-542" />
                  El Problema Real
                </div>
              </div>

              <h2 className="text-2xl md:text-4xl font-extrabold mb-4 text-center max-w-3xl mx-auto leading-tight" data-id="element-543">
                ¿Cuántos meses más vas a depender de un sueldo en pesos que{' '}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-danger to-danger drop-shadow-[0_0_12px_rgba(255,90,90,0.4)]" data-id="element-544">
                  no alcanza?
                </span>
              </h2>

              <div className="mx-auto h-px w-32 bg-gradient-to-r from-transparent via-danger to-transparent opacity-70 mb-5" data-id="element-545"></div>

              <p className="text-base md:text-lg text-textsecondary text-center max-w-2xl mx-auto mb-8" data-id="element-546">
                Querés generar ingresos extra en dólares pero terminás atrapado
                sin saber por dónde empezar, sin claridad sobre qué ofrecer y
                sin un sistema que funcione mientras vos seguís con tu vida.{' '}
                <span className="text-white font-semibold block mt-2" data-id="element-547">
                  No es falta de ganas. Es falta de un sistema.
                </span>
              </p>

              {/* Account stats panel — ecommerce dashboard widgets */}
              <div className="grid grid-cols-2 md:grid-cols-4 gap-3 max-w-3xl mx-auto mb-10" data-id="element-548">
                {[{
                label: 'Pedidos este mes',
                value: '0',
                icon: ShoppingCart
              }, {
                label: 'Ingresos en USD',
                value: '$0',
                icon: Banknote
              }, {
                label: 'Clientes recurrentes',
                value: '0',
                icon: TrendingDown
              }, {
                label: 'Tasa conversión',
                value: '---',
                icon: AlertTriangle
              }].map((stat, i) => <motion.div key={i} initial={{
                opacity: 0,
                y: 10
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: i * 0.05
              }} className="bg-petroleum/60 border border-danger/15 rounded-xl p-3 md:p-4 text-center relative overflow-hidden" data-id="element-549">
                    <stat.icon className="w-4 h-4 text-danger/50 mx-auto mb-1.5" data-id="element-550" />
                    <div className="text-xl md:text-2xl font-extrabold text-danger font-mono mb-0.5" data-id="element-551">
                      {stat.value}
                    </div>
                    <div className="text-[9px] md:text-[10px] text-textsecondary uppercase tracking-wider font-semibold" data-id="element-552">
                      {stat.label}
                    </div>
                  </motion.div>)}
              </div>

              {/* Error log header */}
              <div className="max-w-4xl mx-auto" data-id="element-553">
                <div className="flex items-center justify-between mb-3 px-1" data-id="element-554">
                  <div className="flex items-center gap-2" data-id="element-555">
                    <div className="w-1.5 h-1.5 rounded-full bg-danger animate-pulse" data-id="element-556"></div>
                    <h3 className="text-xs md:text-sm font-bold text-white uppercase tracking-wider" data-id="element-557">
                      Log de errores · Pedidos fallidos
                    </h3>
                  </div>
                  <span className="text-[10px] text-textsecondary font-mono" data-id="element-558">
                    8 / 8 sin resolver
                  </span>
                </div>

                {/* Error rows — failed transactions list */}
                <div className="bg-petroleum/40 border border-white/5 rounded-xl overflow-hidden" data-id="element-559">
                  {pains.map((pain, i) => {
                  const Icon = pain.icon;
                  return <motion.div key={i} initial={{
                    opacity: 0,
                    x: -20
                  }} whileInView={{
                    opacity: 1,
                    x: 0
                  }} viewport={{
                    once: true
                  }} transition={{
                    delay: i * 0.05
                  }} className="group flex items-center gap-3 md:gap-4 px-4 md:px-5 py-3.5 border-b border-white/5 last:border-0 hover:bg-danger/[0.04] transition-colors" data-id="element-560">
                        {/* SKU / Order ID */}
                        <div className="hidden sm:flex items-center gap-2 text-[10px] font-mono text-textsecondary/60 w-20 shrink-0" data-id="element-561">
                          <span className="text-danger" data-id="element-562">#</span>
                          <span data-id="element-563">{pain.sku}</span>
                        </div>

                        {/* Icon thumbnail */}
                        <div className="w-9 h-9 md:w-10 md:h-10 rounded-lg bg-danger/10 border border-danger/20 flex items-center justify-center shrink-0" data-id="element-564">
                          <Icon className="w-4 h-4 md:w-5 md:h-5 text-danger" data-id="element-565" />
                        </div>

                        {/* Description */}
                        <div className="flex-1 min-w-0" data-id="element-566">
                          <p className="text-sm md:text-base text-white font-medium truncate group-hover:text-white" data-id="element-567">
                            {pain.text}
                          </p>
                          <p className="text-[10px] text-textsecondary/60 font-mono mt-0.5" data-id="element-568">
                            estado:{' '}
                            <span className="text-danger" data-id="element-569">declined</span> ·
                            reintentos: <span className="text-danger" data-id="element-570">0/∞</span>
                          </p>
                        </div>

                        {/* Status badge */}
                        <div className="hidden md:flex items-center gap-1.5 bg-danger/15 text-danger border border-danger/30 px-2.5 py-1 rounded-md text-[10px] font-extrabold uppercase tracking-wider shrink-0" data-id="element-571">
                          <XCircle className="w-3 h-3" data-id="element-572" />
                          Fallido
                        </div>

                        {/* Mobile mini badge */}
                        <XCircle className="md:hidden w-5 h-5 text-danger shrink-0" data-id="element-573" />
                      </motion.div>;
                })}
                </div>

                {/* Receipt-style footer */}
                <div className="flex items-center justify-between mt-3 px-1 pt-3 border-t border-dashed border-white/10" data-id="element-574">
                  <span className="text-[10px] text-textsecondary font-mono" data-id="element-575">
                    TOTAL FACTURADO ESTE AÑO:
                  </span>
                  <span className="text-base font-extrabold text-danger font-mono" data-id="element-576">
                    USD 0,00
                  </span>
                </div>
              </div>
            </div>

            {/* Promo banner / CTA — ecommerce style upgrade prompt */}
            <motion.div initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="relative bg-gradient-to-r from-electric/10 via-gold/10 to-electric/10 border-t border-electric/30 px-6 md:px-10 py-6 md:py-7 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-577">
              <div className="flex items-center gap-3 text-center md:text-left" data-id="element-578">
                <div className="w-10 h-10 rounded-xl bg-electric/20 border border-electric/40 flex items-center justify-center shrink-0 hidden md:flex" data-id="element-579">
                  <TrendingDown className="w-5 h-5 text-electric rotate-180" data-id="element-580" />
                </div>
                <div data-id="element-581">
                  <p className="text-[10px] md:text-xs text-electric font-bold uppercase tracking-widest mb-1" data-id="element-582">
                    Solución disponible · Upgrade tu cuenta
                  </p>
                  <h3 className="text-lg md:text-2xl font-extrabold text-white leading-tight" data-id="element-583">
                    ¿Y si este fuera el último mes que pasás así?
                  </h3>
                </div>
              </div>
              <a href="#pricing" className="inline-flex items-center gap-2 bg-electric hover:bg-gold text-graphite font-extrabold px-5 py-3 rounded-xl text-sm uppercase tracking-wide transition-all duration-300 shadow-lg shadow-electric/30 hover:shadow-electric/60 hover:-translate-y-0.5 whitespace-nowrap" data-id="element-584">
                Resolver ahora
                <ArrowRight className="w-4 h-4" strokeWidth={3} data-id="element-585" />
              </a>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}